<template>
  <el-dialog
    title="用户详情"
    :visible.sync="dialogVisible"
    width="800px"
    :before-close="handleClose"
    @close="handleClose"
  >
    <el-tabs v-model="activeTab">
      <el-tab-pane label="基本信息" name="basic">
        <el-form label-width="120px" label-position="left">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="公司名称：">
                <span>{{ userInfo.company_name || '无' }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="手机号：">
                <span>{{ userInfo.mobile || '无' }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="账号状态：">
                <el-tag :type="userInfo.disabled ? 'danger' : 'success'">
                  {{ userInfo.disabled ? '禁用' : '使用中' }}
                </el-tag>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="公司地址：">
                <span>{{ userInfo.company_address || '无' }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="邮箱：">
                <span>{{ userInfo.email || '无' }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="注册时间：">
                <span>{{ formatDate(userInfo.created_at) || '无' }}</span>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-tab-pane>
      
      <el-tab-pane label="用户收件地址" name="address">
        <el-table
          :data="addressList"
          border
          v-loading="addressLoading"
        >
          <el-table-column prop="recipients" label="收件人" align="center" width="120"></el-table-column>
          <el-table-column prop="mobile" label="收件人手机号" align="center" width="130"></el-table-column>
          <el-table-column prop="phone" label="座机" align="center" width="130"></el-table-column>
          <el-table-column label="详细地址" align="center">
            <template slot-scope="scope">
              {{ scope.row.province }}{{ scope.row.city }}{{ scope.row.district }}{{ scope.row.street }}
            </template>
          </el-table-column>
          <el-table-column prop="is_primary" label="默认地址" align="center" width="100">
            <template slot-scope="scope">
              {{ scope.row.is_primary ? '是' : '否' }}
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>
    
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">关 闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { formatDate } from '@/utils/formatter'
import { getUserInfo, getUserAddressList } from '@/api/member'

export default {
  name: 'WccyrUserDetail',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    userId: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      dialogVisible: this.visible,
      activeTab: 'basic',
      addressLoading: false,
      addressList: [],
      userInfo: {}
    }
  },
  watch: {
    visible(newVal) {
      this.dialogVisible = newVal
      if (newVal) {
        // 获取用户详情
        this.fetchUserInfo()
        // 获取用户收件地址
        this.fetchUserAddress()
      }
    }
  },
  methods: {
    handleClose() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
    formatDate,
    // 获取用户详情
    async fetchUserInfo() {
      try {
        const res = await getUserInfo({ id: this.userId })
        if (res.err_code === 0) {
          this.userInfo = res.data || {}
        } else {
          console.error('获取用户详情失败:', res.err_msg)
          this.$message.error('获取用户详情失败: ' + res.err_msg)
        }
      } catch (error) {
        console.error('获取用户详情失败:', error)
        this.$message.error('获取用户详情失败: ' + error.message)
      }
    },
    // 获取用户收件地址
    async fetchUserAddress() {
      this.addressLoading = true
      try {
        // 调用获取用户收件地址的API
        const res = await getUserAddressList({ id: this.userId })
        if (res.err_code === 0) {
          this.addressList = res.rows || []
        } else {
          console.error('获取用户收件地址失败:', res.err_msg)
          this.$message.error('获取用户收件地址失败: ' + res.err_msg)
        }
      } catch (error) {
        console.error('获取用户收件地址失败:', error)
        this.$message.error('获取用户收件地址失败: ' + error.message)
      } finally {
        this.addressLoading = false
      }
    }
  }
}
</script>

<style lang="less" scoped>
.dialog-footer {
  text-align: center;
}
</style>